import {
  slideshow_default
} from "./chunk-I235DIVR.js";

// src/layouts/slideshow/index.ts
var slideshow_default2 = slideshow_default;

export {
  slideshow_default2 as slideshow_default
};
